@if (profile) {
<button matIconButton aria-label="auth button" [matMenuTriggerFor]="menu">
  <mat-icon fontSet="material-symbols-outlined">account_circle</mat-icon>
</button>
<mat-menu #menu="matMenu">
  <div style="padding: 15px 10px">
    <span>{{profile.email}}</span>
  </div>
  <mat-divider></mat-divider>
  <a mat-menu-item routerLink="/account/profile">
    <mat-icon fontSet="material-symbols-outlined">account_circle</mat-icon
    ><span>Profile</span>
  </a>
  <a mat-menu-item routerLink="/shopping/cart">
    <mat-icon fontSet="material-symbols-outlined">shopping_cart</mat-icon
    ><span>Cart</span>
  </a>
  <a mat-menu-item routerLink="/account/orders">
    <mat-icon fontSet="material-symbols-outlined">order_approve</mat-icon
    ><span>Orders</span>
  </a>
  <button mat-menu-item (click)="logout()">
    <mat-icon fontSet="material-symbols-outlined">logout</mat-icon>
    <span>Logout</span>
  </button>
</mat-menu>
}@else{
<a routerLink="/login" matIconButton aria-label="auth button">
  <mat-icon fontSet="material-symbols-outlined">account_circle</mat-icon>
</a>

}
